/** Trường khách hàng của hệ thống có thể gắn vào một giai đoạn (khớp backend cdp/lifecycle-fields.ts BUILTIN_FIELDS). */
import { i18n } from '@/lib/i18n'

export type StageFieldType = 'text' | 'longtext' | 'date'

export const BUILTIN_STAGE_FIELDS: { ref: string; label: string; type: StageFieldType }[] = [
  { ref: 'fullName', get label() { return i18n.t('sharedMisc:stageFields.fullName') }, type: 'text' },
  { ref: 'phone', get label() { return i18n.t('sharedMisc:stageFields.phone') }, type: 'text' },
  { ref: 'email', get label() { return i18n.t('sharedMisc:stageFields.email') }, type: 'text' },
  { ref: 'birthday', get label() { return i18n.t('sharedMisc:stageFields.birthday') }, type: 'date' },
  { ref: 'jobTitle', get label() { return i18n.t('sharedMisc:stageFields.jobTitle') }, type: 'text' },
  { ref: 'notes', get label() { return i18n.t('sharedMisc:stageFields.notes') }, type: 'longtext' },
]

export const PROP_PREFIX = 'prop:'
export const MAX_STAGE_FIELDS = 12

export const builtinField = (ref: string) => BUILTIN_STAGE_FIELDS.find((f) => f.ref === ref)
export const isPropRef = (ref: string) => ref.startsWith(PROP_PREFIX)
export const propKeyOf = (ref: string) => ref.slice(PROP_PREFIX.length)
